// extracted by mini-css-extract-plugin
module.exports = {"productContainer":"TestProducts_productContainer__YcNWY","modeContainer":"TestProducts_modeContainer__2BCyd"};